import React, { ReactNode } from "react";
import { Typography, Box } from "@mui/material";

const ResponseCard = ({
  title,
  message,
  icon,
}: {
  title: string;
  message: ReactNode;
  icon: ReactNode;
}) => {
  return (
    <Box
      sx={{
        mt: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
      }}
    >
      {icon}
      <Typography
        variant="h4"
        my={2}
        sx={{
          fontSize: "20px",
          color: "#000271",
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontSize: "16px",
          color: "#000271",
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default ResponseCard;
